<template>
  <div>
    <v-card flat class="mt-1" :loading="loading">
      <v-form class="multi-col-validation">
        <div class="pa-3">
          <v-card-text>
            <v-card-title class="px-0 pt-0">
              <v-text-field
                class="pt-0"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar..."
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="payments"
              :search="search"
              sort-by="validity"
              :show-select="hasPermission(2097152)"
              :hide-default-footer="payments.length < 10"
            >
              <template v-slot:top>
                <div class="d-flex gap-4 mb-4">
                  <v-btn
                    @click="sendSelectedNotification"
                    color="primary"
                    small
                    :loading="!!sendingNotification.size"
                    :disabled="
                      !!loadingDownload ||
                      !!loading ||
                      !hasContractActive ||
                      selected.length == 0 ||
                      sendingNotification.size > 0
                    "
                  >
                    Enviar {{ selected.length || '' }} Notificação{{ selected.length > 1 ? 's' : '' }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <!-- v-if="hasPermission(1048576)" -->
                  <v-btn
                    @click="openPaymentModal"
                    color="primary"
                    dark
                    >
                    Gerar Pagamento
                  </v-btn>
                  <!-- :disabled="!!loadingDownload || !!loading || !hasContractActive" -->
                </div>
              </template>

              <template v-slot:[`item.validity`]="{ item }">
                {{ item.validity | date }}
              </template>
              <template v-slot:[`item.value`]="{ item }">
                {{ item.value | currency }}
                <small v-if="item.s?.key === 'paidOverdue' && item.penalty > 0" class="d-block">
                  +{{ item.penalty | currency }} multa
                </small>
                <small v-if="item.s?.key === 'paidOverdue' && item.fees > 0" class="d-block">
                  +{{ item.fees | currency }} juros
                </small>
              </template>
              <template v-slot:[`item.payDate`]="{ item }">
                {{ item.payDate | date('DD/MM/YY') }}
              </template>
              <template v-slot:[`item.gateway`]="{ item }">
                <v-chip v-if="item.gateway == 'Externo'" color="primary" small label>
                  {{ item.Bank?.name || paymentDefinitions.gateways[item.gateway]?.text }}
                </v-chip>
                <v-chip v-else-if="item.gateway" :color="paymentDefinitions.gateways[item.gateway]?.color" small label>
                  {{ paymentDefinitions.gateways[item.gateway]?.text }}
                </v-chip>
                <v-chip v-else color="error" small label> Não emitido </v-chip>
              </template>
              <template #[`item.status`]="{ item }">
                <v-chip small :color="item.s.color" label class="font-weight-medium">
                  {{ item.s.text }} {{ item.paymentMethod }}
                </v-chip>
                <small class="d-block text-center" v-if="item.payDate">
                  {{ item.payDate | date('DD/MM/YY') }}
                </small>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :loading="sendingNotification.has(item.id)"
                      :disabled="
                        sendingNotification.has(item.id) ||
                        ['Paid', 'Canceled'].includes(item.status) ||
                        successSend.has(item.id)
                      "
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="sendNotification(item, false)"
                    >
                      <v-icon>{{ successSend.has(item.id) ? 'mdi-send-check-outline' : 'mdi-send' }}</v-icon>
                    </v-btn>
                  </template>
                  <span>Enviar Notificação</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      @click="downloadItem(item)"
                      :loading="loadingDownload == item.id"
                      :disabled="!!loadingDownload || !!loading || ['Paid', 'Canceled'].includes(item.status)"
                    >
                      <v-icon> mdi-barcode </v-icon>
                    </v-btn>
                  </template>
                  <span>Gerar Boleto</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      :disabled="!!loadingDownload || !!loading || ['Paid', 'Canceled'].includes(item.status)"
                      v-if="hasPermission(2097152)"
                      @click="openPaymentDischarge(item)"
                    >
                      <v-icon> mdi-archive-arrow-down</v-icon>
                    </v-btn>
                  </template>
                  <span>Dar Baixa</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      :disabled="!!loadingDownload || !!loading || ['Paid', 'Canceled'].includes(item.status)"
                      v-if="hasPermission(2097152)"
                      @click="openPaymentModal(item)"
                    >
                      <v-icon> mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Pagamento</span>
                </v-tooltip>

                <!-- tree dots -->
                <v-menu :nudge-right="-205" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      :disabled="sendingNotification.has(item.id)"
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="openNotificationHistory(item)"
                    >
                      <v-list-item-action>
                        <v-icon>mdi-history</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Histórico de Notificações</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="hasPermission(4194304)"
                      @click="openPaymentDestroy(item)"
                      :disabled="!!loadingDownload || !!loading || ['Paid', 'Canceled'].includes(item.status)"
                    >
                      <v-list-item-action>
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>Excluir Pagamento</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:no-results>
                <v-btn color="primary" @click="search = ''">Resetar</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </div>
      </v-form>
    </v-card>
    <boleto :rental="rental" />
    <payment-modal @success="$emit('refresh')" />
    <payment-delete @success="$emit('refresh')" />
    <payment-history @success="$emit('refresh')" />
    <payment-discharge @success="$emit('refresh')" />
  </div>
</template>

<script>
import paymentDefinitions from '@/definitions/payment.js'
import rentalService from '@/services/rental'
import Boleto from '@/components/modals/Boleto.vue'
import PaymentHistory from '@/components/modals/PaymentHistory.vue'
import PaymentModal from '@/components/modals/PaymentModal.vue'
import { mapGetters } from 'vuex'
import PaymentDelete from '@/components/modals/PaymentDelete.vue'
import PaymentDischarge from '@/components/modals/PaymentDischarge.vue'

export default {
  components: { Boleto, PaymentModal, PaymentDelete, PaymentHistory, PaymentDischarge },
  data: () => ({
    paymentDefinitions,
    loadingDownload: null,
    search: '',
    successSend: new Set(),
    sendingNotification: new Set(),
    sendingCount: 0,
    selected: [],
    headers: [
      { text: 'Vencimento', value: 'validity', sortable: true },
      { text: 'Valor', value: 'value', sortable: true },
      { text: 'Descrição', value: 'description', sortable: false },
      { text: 'Gateway', value: 'gateway', align: 'center' },
      { text: 'Situação', value: 'status', sortable: true, align: 'center' },
      { text: 'Boleto', value: 'actions', sortable: false, align: 'end' },
    ],
  }),
  methods: {
    openPaymentDischarge(data) {
      this.$emit('payment-discharge', {
        payment: data,
        rental: this.rental,
      })
    },
    openPaymentDestroy(data) {
      this.$emit('payment-delete', {
        payment: data,
        rental: this.rental,
      })
    },
    openPaymentModal(data) {
      this.$emit('payment-modal', {
        payment: data,
        rental: this.rental,
      })
    },
    openNotificationHistory(item) {
      this.$root.$emit('show-payment-history', {
        payment: item,
        rental: this.rental,
      })
    },
    async downloadItem(item) {
      try {
        this.loadingDownload = item.id
        let response = await rentalService.getBoleto(this.rental.id, item.id)
        this.$root.$emit('show-boleto', response)
      } catch (e) {
        this.$toast.fire({
          title: e.message || 'Erro ao gerar boleto',
          icon: 'error',
        })
      } finally {
        this.loadingDownload = null
      }
    },
    async sendNotification(item, hideSuccess = false) {
      try {
        if (this.sendingNotification.has(item.id) || this.successSend.has(item.id)) return
        this.sendingNotification.add(item.id)
        let response = await rentalService.sendBoleto(this.rental.id, item.id)
        this.successSend.add(item.id)

        if (!hideSuccess)
          this.$toast.fire({
            title: 'Notificação enviada com sucesso',
            icon: 'success',
          })
      } catch (e) {
        this.$toast.fire({
          title: e.message || 'Erro ao enviar notificação',
          icon: 'error',
        })
      } finally {
        this.sendingNotification.delete(item.id)
        this.sendingCount++
      }
    },
    async sendSelectedNotification() {
      for (const item of this.selected) {
        await this.sendNotification(item, true)
      }
    },
  },
  computed: {
    ...mapGetters('auth', ['hasPermission']),
    payments() {
      this.sendingCount
      let payments = []
      if (!this.rental) return payments
      this.rental.Contracts.forEach(c => {
        payments.push(...c.Payment)
      })

      payments = payments.map(p => {
        p.s = this.paymentDefinitions.getPaymentStatus(p)
        p.value = parseFloat(p.value)
        p.penalty = parseFloat(p.penalty)
        p.fees = parseFloat(p.fees)
        p.discount = parseFloat(p.discount)
        return p
      })

      return payments
    },
    hasContractActive() {
      return this.rental.Contracts.some(contract => contract.status === 'active' || contract.status === 'pending')
    },
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    rental: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.v-card__title {
  text-align: center !important;
  display: inherit;
}
</style>
